<section class="home-card bank-limits" aria-labelledby="home-bank-limits-title">
  <div class="home-card__header">
    <h2 id="home-bank-limits-title" class="home-card__title">Limites Bancários</h2>
    <button
      type="button"
      class="home-card__info"
      aria-label="Como o disponível é calculado"
      pTooltip="4131 disponível = limite informado pelo banco menos o saldo devedor das operações contratadas, em reais pela PTAX D-1. Derivativos: o valor livre que o banco informou."
      tooltipPosition="left">
      <i class="pi pi-info-circle"></i>
    </button>
  </div>

  @if (!companyId()) {
    <div class="home-card__empty">
      <i class="pi pi-building"></i>
      <span>Escolha uma única empresa no seletor do topo para ver os limites.</span>
    </div>
  } @else if (loading()) {
    <div class="bank-limits__loading" role="status" aria-label="Carregando os limites bancários">
      <span class="home-skeleton home-skeleton--box"></span>
      @for (item of [0, 1, 2]; track item) {
        <div class="bank-limits__skeleton-row">
          <span class="home-skeleton home-skeleton--avatar"></span>
          <span class="bank-limits__skeleton-lines">
            <span class="home-skeleton home-skeleton--wide"></span>
            <span class="home-skeleton home-skeleton--short"></span>
          </span>
        </div>
      }
    </div>
  } @else if (failed()) {
    <div class="home-card__error" role="alert">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Não foi possível carregar os limites agora. Tente de novo.</span>
      <app-button
        label="Tentar de novo"
        theme="white"
        size="small"
        [noMargin]="true"
        (sendClick)="retry()"></app-button>
    </div>
  } @else {
    <div class="bank-limits__total">
      <p class="bank-limits__total-label">Total Disponível 4131</p>
      <!-- Sem limite vigente o total é "—", não R$ 0,00 (crítica de design F2, N3). -->
      <p class="bank-limits__total-value">
        {{ allNotInformed() ? '—' : (totalAvailable() | vaultFormatCurrency: 2 : 'R$') }}
      </p>
      @if (allNotInformed()) {
        <p class="bank-limits__total-caption">Nenhum limite vigente cadastrado</p>
        <!-- O card só aparece com BANKRELATIONSHIP_LIST, a mesma permissão da lista de relacionamentos. -->
        <a class="home-card__link bank-limits__total-link" [routerLink]="relationshipsRoute">
          <i class="pi pi-plus"></i>
          Cadastrar limites
        </a>
      } @else {
        <p class="bank-limits__total-caption">Soma dos limites vigentes</p>
      }
    </div>

    @if (!hasBanks()) {
      <div class="home-card__empty">
        <i class="pi pi-building-columns"></i>
        <span
          >Nenhum relacionamento bancário cadastrado para esta empresa. Cadastre em Ver
          Relacionamentos.</span
        >
      </div>
    } @else {
      <ul class="bank-limits__list">
        @for (row of rows(); track row.id) {
          <li class="bank-limits__row">
            <div class="bank-limits__row-main">
              <app-home-bank-avatar [bankName]="row.bankName" [bankCode]="row.bankCode" />
              <div class="bank-limits__name-block">
                <p class="bank-limits__name">{{ row.bankName }}</p>
                @if (row.warning) {
                  <p class="bank-limits__warning">
                    <i class="pi pi-exclamation-triangle"></i>
                    <span>{{ row.warning.headline }}</span>
                  </p>
                } @else if (row.validityEnd) {
                  <p class="bank-limits__muted">Vigência até {{ row.validityEnd }}</p>
                }
              </div>
              @if (row.isOk && row.has4131) {
                <div class="bank-limits__available">
                  <p class="bank-limits__available-value">
                    {{ row.available | vaultFormatCurrency: 2 : 'R$' }}
                  </p>
                  <p class="bank-limits__muted">disponível 4131</p>
                </div>
              }
            </div>

            <div class="bank-limits__row-detail">
              @if (row.warning) {
                <p class="bank-limits__muted bank-limits__muted--text">{{ row.warning.detail }}</p>
              } @else {
                @if (row.has4131) {
                  <div
                    class="bank-limits__bar"
                    role="progressbar"
                    [attr.aria-valuenow]="row.usagePct"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [attr.aria-label]="'Limite 4131 utilizado: ' + row.usagePct + '%'">
                    <span
                      class="bank-limits__bar-fill"
                      [class.bank-limits__bar-fill--warning]="row.usageTone === 'warning'"
                      [class.bank-limits__bar-fill--danger]="row.usageTone === 'danger'"
                      [style.width.%]="row.usagePct"></span>
                  </div>
                }
                <div class="bank-limits__facts">
                  @if (row.has4131) {
                    <span>Utilizado {{ row.usedLabel }} de {{ row.totalLabel }}</span>
                  } @else {
                    <span>Sem limite de 4131 vigente</span>
                  }
                  <span
                    >Derivativos livres <b>{{ row.derivativesLabel }}</b></span
                  >
                  @if (row.lastUpdatedAt) {
                    <span class="bank-limits__updated">
                      <i class="pi pi-refresh"></i>
                      Atualizado em {{ row.lastUpdatedAt | vaultDate }}
                    </span>
                  }
                </div>
              }
              <app-home-bank-limit-update-actions
                [bankName]="row.bankName"
                [request]="row.request"
                [proposal]="row.proposal"
                [requesting]="requestingIds().has(row.financialInstitutionId)"
                (requestClick)="requestUpdate(row)"
                (proposalClick)="openProposal($event)" />
            </div>
          </li>
        }
        @if (notInformedGroup(); as group) {
          <li class="bank-limits__row bank-limits__row--group">
            <div class="bank-limits__row-main">
              <span class="bank-limits__stack" aria-hidden="true">
                @for (bank of group.visibleLogos; track bank.id) {
                  <app-home-bank-avatar
                    size="small"
                    [bankName]="bank.bankName"
                    [bankCode]="bank.bankCode" />
                }
                @if (group.hiddenCount > 0) {
                  <span
                    class="bank-limits__avatar bank-limits__avatar--small bank-limits__avatar--more"
                    >+{{ group.hiddenCount }}</span
                  >
                }
              </span>
              <div class="bank-limits__name-block">
                <p class="bank-limits__name">{{ group.headline }}</p>
                <p class="bank-limits__muted">{{ group.detail }}</p>
                @if (group.action; as action) {
                  <div class="bank-limits__group-action">
                    @if (action.kind === 'button') {
                      <app-button
                        [label]="action.label"
                        icon="pi pi-send"
                        theme="white"
                        size="small"
                        [noMargin]="true"
                        [isLoading]="isGroupRequesting()"
                        loadingText="Enviando..."
                        [disabled]="isGroupRequesting()"
                        (sendClick)="requestGroup(action.financialInstitutionIds)"></app-button>
                    } @else {
                      <a class="bank-limits__group-hint" [routerLink]="relationshipsRoute">
                        <i class="pi pi-info-circle"></i>
                        {{ action.text }}
                      </a>
                    }
                  </div>
                }
              </div>
              <button
                type="button"
                class="bank-limits__toggle"
                [attr.aria-expanded]="notInformedExpanded()"
                aria-controls="home-bank-limits-not-informed"
                (click)="toggleNotInformed()">
                {{ notInformedExpanded() ? 'Ocultar' : 'Ver' }}
                <i
                  class="pi pi-chevron-down"
                  [class.bank-limits__toggle-icon--open]="notInformedExpanded()"></i>
              </button>
            </div>
            @if (notInformedExpanded()) {
              <ul id="home-bank-limits-not-informed" class="bank-limits__plain-list">
                @for (bank of group.banks; track bank.id) {
                  <li>
                    <div class="bank-limits__plain-row">
                      <app-home-bank-avatar
                        size="small"
                        [bankName]="bank.bankName"
                        [bankCode]="bank.bankCode" />
                      <span class="bank-limits__plain-name">{{ bank.bankName }}</span>
                    </div>
                    <app-home-bank-limit-update-actions
                      [bankName]="bank.bankName"
                      [request]="bank.request"
                      [proposal]="bank.proposal"
                      [requesting]="requestingIds().has(bank.financialInstitutionId)"
                      (requestClick)="requestUpdate(bank)"
                      (proposalClick)="openProposal($event)" />
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    }
  }

  <div class="home-card__footer">
    @if (companyId() && !loading() && !failed()) {
      <app-home-bank-limits-update-footer [schedule]="schedule()" />
    }
    <a class="home-card__link bank-limits__footer-link" [routerLink]="relationshipsRoute">
      Ver Relacionamentos
      <i class="pi pi-arrow-right"></i>
    </a>
  </div>
</section>

<app-modal-bank-limit-proposal #proposalModal (decided)="reload(true)" />
